import SignOut from "./SignOut";

export default SignOut;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/SignOut/index.tsx